import type { Components } from '@mui/material';

export const MuiDialogContentText: Components['MuiDialogContentText'] = {
  styleOverrides: {
    root: {
      color: '#243353',
    },
  },
};